import dayjsLib, { Dayjs, OpUnitType, QUnitType } from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import moment from 'moment-timezone';

dayjsLib.extend(utc);
dayjsLib.extend(timezone);
dayjsLib.extend(customParseFormat);
dayjsLib.extend(quarterOfYear);
dayjsLib.extend(updateLocale);

dayjsLib.updateLocale('en', {
    weekStart: 1,
});

const USE_MOMENT = typeof document === 'undefined';

const timezoneMap: Record<string, string> = {
    'Asia/Saigon': 'Asia/Ho_Chi_Minh',
    'US/Pacific': 'America/Los_Angeles',
    'US/Eastern': 'America/New_York',
    'UTC': 'Etc/UTC',
};

export const convertTimezone = (tz?: string): string => {
    if (!tz) return defaultTimezone();
    try {
        const valid = Intl.DateTimeFormat(undefined, { timeZone: tz }).resolvedOptions().timeZone;
        return valid;
    } catch {
        return timezoneMap[tz || ''] || tz!;
    }
};

const defaultTimezone = (): string => {
    return USE_MOMENT ? moment.tz.guess() : dayjsLib.tz.guess();
};

let _timezone = defaultTimezone();

const setTimezone = (tz?: string) => {
    const newTz = convertTimezone(tz);
    _timezone = newTz;
    if (!USE_MOMENT) {
        dayjsLib.tz.setDefault(newTz);
    }
};

const dayjs = (input?: string | Date | Dayjs): Dayjs => {
    if (USE_MOMENT) {
        const momentDate = moment.tz(input, _timezone);
        const offsetMinutes = momentDate.utcOffset();
        return dayjsLib(input).tz(_timezone).utcOffset(offsetMinutes);
    }

    return dayjsLib(input).tz(_timezone);
};

const _dayjs = dayjsLib;

export { setTimezone, dayjs, _dayjs, Dayjs, defaultTimezone };

export type { OpUnitType, QUnitType };
